import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderBGDevotional from "../../../../src/content/bgdevotional/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderBGDevotional,
  React
};